import BaseLayout from 'components/layouts/BaseLayout/BaseLayout';

export default BaseLayout;
